import { VERSES } from "@/data/verses";
import { BIBLE_BOOKS } from "@/data/bibleBooks";
import { storage } from "@/lib/storage";
import { scriptureHref, firstScriptureRef } from "@/lib/scripture";
import { Link } from "@/router/Router";
import { Button } from "@/components/ui/Button";
import { Container, Eyebrow } from "@/components/ui/Primitives";
import { Reveal } from "@/components/motion/Reveal";
import { Icon } from "@/components/ui/Icon";

const POPULAR = ["psalms", "proverbs", "john", "romans", "ephesians", "genesis"];

/** The Word: verse of the day, continue reading, popular books. */
export function Word() {
  const dayIndex = Math.floor(Date.now() / 86_400_000) % VERSES.length;
  const verse = VERSES[dayIndex];
  const ref = firstScriptureRef(verse.reference);
  const recent = storage.getJSON<{ bookId: string; chapter: number }>("ma.bible.last");
  const recentBook = recent ? BIBLE_BOOKS.find((b) => b.id === recent.bookId) : undefined;

  return (
    <section className="word" aria-labelledby="word-title">
      <Container>
        <div className="word__grid">
          <Reveal className="word__verse" variant="fade">
            <Eyebrow index="10" tone="leaf">
              Verse for today
            </Eyebrow>
            <blockquote>
              <p id="word-title" className="word__text">
                “{verse.text}”
              </p>
              <cite className="word__ref">
                {ref ? <Link to={scriptureHref(ref)}>{verse.reference}</Link> : verse.reference}
              </cite>
            </blockquote>
          </Reveal>
          <Reveal className="word__panel" delay={120}>
            <p className="word__panel-title">Open the Word</p>
            <p className="word__panel-text">Read any book and chapter, with clean, distraction-free typography.</p>
            {recentBook && recent ? (
              <Link to={`/bible/${recentBook.id}/${recent.chapter}`} className="word__continue">
                <Icon name="book" size={18} />
                <span>
                  Continue reading <strong>{recentBook.name} {recent.chapter}</strong>
                </span>
                <Icon name="arrowRight" size={16} />
              </Link>
            ) : null}
            <div className="word__books">
              {POPULAR.map((id) => {
                const b = BIBLE_BOOKS.find((x) => x.id === id);
                return b ? (
                  <Link key={id} to={`/bible/${b.id}/1`} className="area-chip">
                    {b.name}
                  </Link>
                ) : null;
              })}
            </div>
            <Button to="/bible" variant="ghost" iconRight="arrowRight">
              Open the Bible
            </Button>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
